import { render } from "./Relacion_Actores.vue?vue&type=template&id=244da3a6"
import script from "./Relacion_Actores.vue?vue&type=script&lang=js"
export * from "./Relacion_Actores.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__